import { render } from "./Other.vue?vue&type=template&id=e313140c&bindings={\"message\":\"data\"}"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Other.vue?vue&type=style&index=0&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script